import { FilterConfig, SearchBarConfig } from './../../../models/table-list-request.interface';
import { Component, ViewContainerRef } from '@angular/core';
import { PaginatedListDataResponse } from '../../../models/paginated-list-data-response';
import { TableMenuOption, TableMeta } from '../../../models/table-meta.interface';
import { StatsData } from '../../../models/stats-response.interface';
import { TableListRequest, Where } from '../../../models/table-list-request.interface';
import { LoadingService } from '../../../services/loading.service';
import { MasterService } from '../../../services/masters-service';
import { ToasterService } from '../../../services/toaster.service';
import vehicleMasterMetaConfig from './config/vehicleMasterMeta.json';
import { RightPanelComponent } from '../../right-panel/right-panel.component';
import { ManageVehicleComponent } from './manage-vehicle/manage-vehicle.component';
import { ModalComponent } from '../../modal/modal.component';
import { AdvancedFilterComponent } from '../../advanced-filter/advanced-filter.component';
import { ConfirmDialogComponent } from '../../confirm-dialog/confirm-dialog.component';
import { TosTableComponent } from "../../tos-table/tos-table.component";
import { DatePipe, NgForOf, NgIf, NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ResizableModule, ResizeEvent } from 'angular-resizable-element';
import { HighlightPipe } from '../../../pipes/highlight.pipe';
import { EditableTableComponent } from '../../editable-table/editable-table.component';
import { NoDataFoundComponent } from '../../no-data-found/no-data-found.component';
import { NoDataComponent } from '../../no-data/no-data.component';
import { SvgIconComponent } from '../../svg-icon/svg-icon.component';
import { TableMenuComponent } from '../../table-menu/table-menu.component';
import { User } from '../../../models/user.interface';
import { AdvancedFilterComponentV2 } from '../../advanced-filter/advanced-filter-v2.component';
import { AdvancedFilterFieldInfo } from '../../../models/advanced-filter-config.interface';
import { CommonUtils } from '../../../utils/common-utils';
import { PermissionConstants } from '../../../constants/permission-constants';
import { RequiresPermissionDirective } from '../../../directives/evaluate-permission.directive';


@Component({
  selector: 'app-vehicletype-master',
  standalone: true,
  imports: [
    TosTableComponent,
    FormsModule,
    EditableTableComponent,
    DatePipe,
    HighlightPipe,
    NgForOf,
    NgIf,
    NoDataComponent,
    NoDataFoundComponent,
    ResizableModule,
    SvgIconComponent,
    TableMenuComponent,
    NgClass,
    TosTableComponent,
    RequiresPermissionDirective,
  ],
  templateUrl: './vehicletype-master.component.html',
  styleUrl: './vehicletype-master.component.scss',
})
export class VehicleTypeMasterComponent {
  protected readonly PermissionConstants = PermissionConstants;
  protected readonly VehicleMasterMetaConfig = vehicleMasterMetaConfig

  isFilterApplied: boolean = false;
  searchTerm: any;
  focusSearch!: boolean;
  tableLoaded: boolean = false;
  tableListData: PaginatedListDataResponse = {
    totalCount: 0,
    page: 0,
    limit: 0,
    records: [],
  };
  tableMeta!: TableMeta;
  filterConfig!: any;   // FilterConfig interface not working
  searchBarConfig!: SearchBarConfig;

  tableStats: StatsData = {
    total: 0,
    active: 0,
    inactive: 0,
  };
  sortColumn: string = 'modifiedDate';
  openMenuIndex: number | null = null;
  menuOptions: TableMenuOption[] = [
    {
      label: 'Edit',
      value: 'edit',
      requiresPermission: { permissionIds: [PermissionConstants.MASTERS.VEHICLETYPE_MASTER.EDIT] },
    },
    { label: 'View', value: 'view' },
    {
      label: 'Mark as active',
      value: 'active',
      condition: (record) => !record.active,
      requiresPermission: { permissionIds: [PermissionConstants.MASTERS.VEHICLETYPE_MASTER.EDIT] },
    },
    {
      label: 'Mark as inactive',
      value: 'inactive',
      condition: (record) => record.active,
      requiresPermission: { permissionIds: [PermissionConstants.MASTERS.VEHICLETYPE_MASTER.EDIT] },
    },
  ];
  totalTablePages: number = 0;
  currentTablePage: number = 1;
  sortDirection: 'asc' | 'desc' = 'desc';
  rowsPerPage: number = 25;
  currentPage: number = 0;
  tableListRequest: TableListRequest = {
    selectFields: [
      'id',
      'name',
      'description',
      'active',
      'modifiedDate',
      'modifiedBy',
    ],
    orderBy: {
      [this.sortColumn]: this.sortDirection,
    },
    limit: this.rowsPerPage,
    page: this.currentPage,
  };
  allTableRecordsSelected: boolean = false;
  selectedItems: any[] = [];
  previousTerm: string = '';
  filterData: Where | null = null;
  rawFilterData: Where | null = null;
  searchFilterData!: Where | null;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private loadingService: LoadingService,
    private masterService: MasterService,
    private toasterService: ToasterService
  ) {}

  ngOnInit() {
    this.tableMeta = vehicleMasterMetaConfig.vehicleMasterTableConfig;

    this.fetchAllRecords();
  }

  fetchAllRecords() {
    this.loadingService.show('inline');

    this.masterService.getVehicleList(this.tableListRequest).subscribe({
      next: (res: any) => {
        this.tableListData = res.data;
        this.tableLoaded = true;
        this.loadingService.hide();
      },
      error: (error: Error) => {
        console.error('Error occurred:', error);
        this.tableLoaded = false;
        this.loadingService.hide();
      },
    });
  }

  menuAction(
    actionName: string,
    successMsg: string,
    flag: boolean,
    userId: string
  ) {
    switch (actionName) {
      case 'active':
      case 'inactive':
        this.masterService.setVehicleStatus(flag, [userId]).subscribe({
          next: () => {
            this.toasterService.success(successMsg);
            this.refreshTableList();
          },
          error: (err) => {
            console.error(err);
            this.toasterService.error(err.error.errorDesc || 'Unknown Error !');
          },
        });
        break;
      default:
        console.error('unknown actionName');
        break;
    }
  }
  private refreshTableList() {
    this.fetchAllRecords();
  }

  addVehicle() {
    const rightPanelRef =
      this.viewContainerRef.createComponent(RightPanelComponent);
    rightPanelRef.instance.title = 'Add Vehicle';
    rightPanelRef.instance.showActionBtns = true;
    rightPanelRef.instance.primaryActionBtnText = 'Save';
    const manageVehicleRef = rightPanelRef.instance.loadComponent(
      ManageVehicleComponent
    );

    const manageVehicleInstance = manageVehicleRef.instance;

    rightPanelRef.instance.primaryActionBtnEmitter.subscribe(() => {
      console.log('Save button clicked inside Right Panel');
      manageVehicleInstance.onSubmit();
    });
    manageVehicleInstance.onSuccessfulSave?.subscribe(() => {
      this.refreshTableList();
      rightPanelRef.destroy();
    });

    rightPanelRef.instance.close.subscribe((res: any) => {
      rightPanelRef.destroy();
    });
  }

  editVehicle(vehicleId: String, actionName: any) {
    const rightPanelRef =
      this.viewContainerRef.createComponent(RightPanelComponent);
    rightPanelRef.instance.title =
      actionName === 'edit' ? 'Edit Bank' : 'View Bank';
    rightPanelRef.instance.showActionBtns = true;
    rightPanelRef.instance.primaryActionBtnText =
      actionName === 'edit' ? 'Save' : 'view';
    rightPanelRef.instance.hidePrimaryButton =
      actionName === 'view' ? true : false;

    const componentRef = rightPanelRef.instance.loadComponent(
      ManageVehicleComponent,
      {
        vehicleId,
        mode: actionName,
      }
    );

    const manageVehicleInstance = componentRef.instance;

    if (actionName === 'edit') {
      rightPanelRef.instance.primaryActionBtnEmitter.subscribe(() => {
        console.log('Save button clicked inside Right Panel');
        manageVehicleInstance.onSubmit();
      });
    }
    manageVehicleInstance.onSuccessfulSave?.subscribe(() => {
      this.refreshTableList();
      rightPanelRef.destroy();
    });

    rightPanelRef.instance.close.subscribe((res: any) => {
      if (res?.refresh) {
        this.refreshTableList();
      }
      rightPanelRef.destroy();
    });
  }

  handleOptionSelected(event: any) {
    // record: any, actionName: any
    const { record: record, actionName } = event;
    const recordId = record.id;
    if (actionName === 'edit' || actionName === 'view') {
      this.editVehicle(recordId, actionName);
    } else this.statusAction(record, actionName);
  }

  statusAction(record: any, actionName: any) {
    const recordId = record.id;
    console.log('record structure', record);
    {
      let actionTitle = 'Confirmation';
      let message = 'Are you sure ?';
      let successMsg = 'Done !';
      let flag = false;
      switch (actionName) {
        case 'active':
        case 'inactive':
          if (actionName === 'active') {
            flag = true;
          }
          actionTitle = `${flag ? 'Activate' : 'Inactivate'} Vehicle`;
          message = `Are you sure to ${flag ? 'activate' : 'inactivate'} ${
            record.name
          } ?`;
          successMsg = `Successfully ${flag ? 'activated' : 'inactived'} ${
            record.name
          } !`;
          break;

        default:
          console.error('unknown actionName');
          break;
      }
      const modalRef = this.viewContainerRef.createComponent(ModalComponent);
      modalRef.instance.title = actionTitle;
      const confirmDialogRef = modalRef.instance.loadComponent(
        ConfirmDialogComponent
      );
      confirmDialogRef.instance.message = message;
      confirmDialogRef.instance.confirm.subscribe(() => {
        this.menuAction(actionName, successMsg, flag, recordId!);
        modalRef.destroy();
      });
      confirmDialogRef.instance.cancel.subscribe(() => {
        modalRef.destroy();
      });
      modalRef.instance.close.subscribe(() => modalRef.destroy());
    }
  }

  isAllRecordsOfCurrentPageSelected() {
    return (
      this.allTableRecordsSelected ||
      (this.tableListData.records?.length > 0 &&
        this.tableListData.records?.every((item: User) =>
          this.isSelected(item)
        ))
    );
  }

  isSelected(item: any) {
    if (this.allTableRecordsSelected) {
      return true;
    } else {
      const recordIdx = this.selectedItems.findIndex((x) => x.id === item.id);
      if (recordIdx !== -1) {
        return true;
      } else {
        return false;
      }
    }
  }

  handleMenuToggle(i: number) {
    this.openMenuIndex = this.openMenuIndex === i ? null : i;
  }

  bulkActionConfirmation(action: 'setActive' | 'setInActive') {
    if (this.selectedItems.length === 0) {
      this.toasterService.error('Please select at least one record!');
      return;
    }

    const flag = action === 'setActive';
    const statusText = flag ? 'activate' : 'inactivate';
    const successText = flag ? 'activated' : 'inactivated';
    const vehicleTypesNames = this.selectedItems
      .map((item) => item.name)
      .join(', ');

    const modalRef = this.viewContainerRef.createComponent(ModalComponent);
    modalRef.instance.title = `Confirm ${flag ? 'Activation' : 'Inactivation'}`;
    const confirmDialogRef = modalRef.instance.loadComponent(
      ConfirmDialogComponent
    );
    confirmDialogRef.instance.message = `Are you sure you want to ${statusText} the selected vehicles: ${vehicleTypesNames}?`;

    confirmDialogRef.instance.confirm.subscribe(() => {
      const ids = this.selectedItems.map((item) => item.id);
      this.masterService.setVehicleStatus(flag, ids).subscribe({
        next: () => {
          this.toasterService.success(
            `Successfully ${successText} selected vehicles!`
          );
          this.selectedItems = [];
          this.allTableRecordsSelected = false;
          this.refreshTableList();
          modalRef.destroy();
        },
        error: (err) => {
          console.error(err);
          this.toasterService.error(
            err.error?.errorDesc || 'Operation failed.'
          );
          modalRef.destroy();
        },
      });
    });

    confirmDialogRef.instance.cancel.subscribe(() => modalRef.destroy());
    modalRef.instance.close.subscribe(() => modalRef.destroy());
  }
}
